import { render, staticRenderFns } from "./SuccessTransfer.vue?vue&type=template&id=3ed1223e&scoped=true&"
import script from "./SuccessTransfer.vue?vue&type=script&lang=js&"
export * from "./SuccessTransfer.vue?vue&type=script&lang=js&"
import style0 from "./SuccessTransfer.vue?vue&type=style&index=0&id=3ed1223e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed1223e",
  null
  
)

export default component.exports